import { HTMLInputTypeAttribute } from 'react';
import { IIconName } from 'v2/resources/types/icon';

export interface IInput {
  value?: string | number | readonly string[];
  disabled?: boolean;
  placeholder?: string;
  type?: HTMLInputTypeAttribute;
  width?: number | string;
  maxWidth?: number | string;
  errorMessage?: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  name?: string;
  label?: string;
  colorLabel?: string;
}

export interface IInputSyle {
  width?: number | string;
  maxWidth?: number | string;
}
export interface IError {
  error?: boolean;
}

export const COLOR_ERROR = '#f44336';
export const COLOR_BACKGROUND_ERROR = '#fff1ee';
export const COLOR_DEFAULT = '#1c4d1e';
